import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-documents-csv-icon',
  templateUrl: './documents-csv.component.html'
})
export class DocumentsCsvComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
